import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/contratositens/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const findContracItem = async ({ empresa_cnpj, id }) => {
  return search(`${path}/${id}?empresa_cnpj=${empresa_cnpj}`, "GET", headers);
};
